import React from 'react'

const CustomExpandableStepper = ({item}) => {
  return (
     <ul className="custom__accordion">
        {item.options.map((option, index) => (
            <li
            key={index}
            className={item.selectedIdx === index + 1 ? 'active' : item.selectedIdx > index + 1 ? 'completed' : ''}
            onClick={() => item.setSelectedIdx(index + 1)}
            >
            <span className="dot"></span>
            <div className="right">
                <p className="text--bold custom__accordion-title">{option.title}</p>
                <div className="desc__container">
                <p className="text--gray text--regular custom__accordion-desc">{option.description}</p>
                </div>
            </div>
            </li>
        ))}
    </ul>
  )
}

export default CustomExpandableStepper